import React, { useEffect } from 'react';
import { Layout } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { auth } from '../../services/api';
import { setUser, selectUser } from '../../store/userSlice';

const { Content } = Layout;

const MainLayout: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token && !user) {
      const fetchUser = async () => {
        try {
          const userData = await auth.getCurrentUser();
          dispatch(setUser(userData));
        } catch (error) {
          console.error('Failed to fetch user:', error);
          localStorage.removeItem('token');
        }
      };
      fetchUser();
    }
  }, [dispatch, navigate, user]);

  return (
    <Layout>
      <Content>
        <Outlet />
      </Content>
    </Layout>
  );
};

export default MainLayout; 